class SmartcapHeader extends HTMLElement {
  connectedCallback() {
    this.hideDelay = null;
    this.megaTrigger = this.querySelector('[data-mega-trigger]');
    this.megaToggle = this.querySelector('[data-mega-toggle]');
    this.megaMenu = this.querySelector('[data-mega-menu]');
    this.mobileToggle = this.querySelector('[data-mobile-toggle]');
    this.mobileNav = this.querySelector('[data-mobile-nav]');
    this._onSectionLoad = this._handleSectionLoad.bind(this);
    this._onDocumentClick = this._handleDocumentClick.bind(this);
    this._onResize = this._handleResize.bind(this);

    this._bindEvents();
    this._resetState();

    document.addEventListener('shopify:section:load', this._onSectionLoad);
    document.addEventListener('click', this._onDocumentClick);
    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:section:load', this._onSectionLoad);
    document.removeEventListener('click', this._onDocumentClick);
    window.removeEventListener('resize', this._onResize);
    this._clearHideDelay();
  }

  _bindEvents() {
    if (this.megaTrigger && this.megaMenu) {
      this.megaTrigger.addEventListener('mouseenter', () => this._openMegaMenu());
      this.megaTrigger.addEventListener('mouseleave', () => this._scheduleMegaClose());
      this.megaMenu.addEventListener('mouseenter', () => this._clearHideDelay());
      this.megaMenu.addEventListener('mouseleave', () => this._scheduleMegaClose());
    }

    if (this.mobileToggle) {
      this.mobileToggle.addEventListener('click', () => this._toggleMobileNav());
    }
  }

  _handleSectionLoad(event) {
    const section = this.closest(`#shopify-section-${event.detail.sectionId}`);
    if (!section) return;
    this._resetState();
  }

  _handleDocumentClick(event) {
    if (this.contains(event.target)) return;
    this._closeMegaMenu();
    this._closeMobileNav();
  }

  _handleResize() {
    if (window.innerWidth > 749) {
      this._closeMobileNav();
    }
  }

  _toggleMobileNav() {
    const isOpen = this.dataset.mobileOpen === 'true';
    if (isOpen) {
      this._closeMobileNav();
    } else {
      this._openMobileNav();
    }
  }

  _openMobileNav() {
    this.dataset.mobileOpen = 'true';
    if (this.mobileToggle) this.mobileToggle.setAttribute('aria-expanded', 'true');
    if (this.mobileNav) this.mobileNav.hidden = false;
  }

  _closeMobileNav() {
    this.dataset.mobileOpen = 'false';
    if (this.mobileToggle) this.mobileToggle.setAttribute('aria-expanded', 'false');
    if (this.mobileNav) this.mobileNav.hidden = true;
  }

  _openMegaMenu() {
    if (window.innerWidth <= 749 || !this.megaMenu) return;
    this._clearHideDelay();
    this.dataset.megaOpen = 'true';
    this.megaMenu.setAttribute('aria-hidden', 'false');
    if (this.megaToggle) this.megaToggle.setAttribute('aria-expanded', 'true');
  }

  _closeMegaMenu() {
    this.dataset.megaOpen = 'false';
    if (this.megaMenu) this.megaMenu.setAttribute('aria-hidden', 'true');
    if (this.megaToggle) this.megaToggle.setAttribute('aria-expanded', 'false');
  }

  _scheduleMegaClose() {
    this._clearHideDelay();
    this.hideDelay = window.setTimeout(() => this._closeMegaMenu(), 200);
  }

  _clearHideDelay() {
    if (!this.hideDelay) return;
    window.clearTimeout(this.hideDelay);
    this.hideDelay = null;
  }

  _resetState() {
    this._closeMegaMenu();
    this._closeMobileNav();
  }
}

if (!customElements.get('smartcap-header')) {
  customElements.define('smartcap-header', SmartcapHeader);
}
